import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { IWGSharedService } from '../services/shared.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private userService: UserService, private sharedService: IWGSharedService, ) { }
    embedStatus = "notembed";  
    canActivate = () => {
        var hasaccessToken = false;
        if (localStorage.getItem('accessToken')) {
            hasaccessToken = true;
        }

        if (this.sharedService.getIsEmbed()) {           
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const embed = urlParams.get('embed');

            var hasaccessTokenIframe = false;
            if (localStorage.getItem('accessTokenCxp')) {
                hasaccessTokenIframe = true;
            }

            if (hasaccessTokenIframe == false) {
                var userid = "";
                if (embed === "1") {
                    if (window.location && window.location.href && window.location.href.indexOf('myGuides') > 0) {
                        sessionStorage.setItem("NavigatePath", 'myGuides');
                    }                    
                    userid = urlParams.get('UID');
                    localStorage.setItem("UID", userid);

                } else {
                    userid = localStorage.getItem('UID')
                }
                localStorage.setItem("UID", userid);

                if (userid && userid !== "") {
                    this.userService.getEmbedLoginTokenMyGuide(userid)
                        .subscribe((result) => {
                            if (result && result.data && result.data.text) {
                                localStorage.setItem("accessTokenCxp", result.data.text);
                                var path = sessionStorage.getItem('NavigatePath');
                                this.router.navigate([path]);
                                return true;
                            }
                            else {
                                return true;
                            }
                        });
                }
            } else {
                return true;
            }
        }
        else {
            if (hasaccessToken === false) {
                console.log("canActivate: login")
                this.router.navigate(['login']);
            };
            return hasaccessToken;
        }
    };
    canLoad = () => {
        var hasaccessToken = false;
        if (localStorage.getItem('accessToken')) {
            hasaccessToken = true;
        }
        if (this.sharedService.getIsEmbed()) {
            var hasaccessTokenIframe = false;
            if (localStorage.getItem('accessTokenCxp')) {
                hasaccessTokenIframe = true;
            }

            const queryString = window.location.search;
            var pathName = window.location.pathname
            if (queryString !== null && queryString !== '') {
                pathName = pathName + queryString;
            }
            const urlParams = new URLSearchParams(queryString);
            var uIDKeywordName = "dcf37f76a";
            var userid = urlParams.get(uIDKeywordName);
            if (userid !== '' && userid !== null && hasaccessTokenIframe == true)
            {
                //var existing_userId = localStorage.getItem(uIDKeywordName);
                //if(existing_userId!==userid){
                hasaccessTokenIframe=false;
                //}
            }

            if (hasaccessTokenIframe == false) {     
                if (userid === '' || userid === null) {
                    userid = localStorage.getItem(uIDKeywordName)
                } else {
                    localStorage.setItem(uIDKeywordName, userid);
                }              
                if (userid && userid !== "") {
                    const props = {
                        userId: userid
                    };
                    this.userService.getEmbedLoginToken(props)
                        .subscribe((result) => {
                            if (result && result.data) {                         
                                this.userService.setUserData(result.data);
                                this.router.navigateByUrl(pathName);
                                return true;
                            }
                            else {
                                return true;
                            }
                        });
                }
            } else {
                return true;
            }
        }
        else {
            if (hasaccessToken === false) {
                console.log("canActivate: login")
                this.router.navigate(['login']);
            };
            return hasaccessToken;
        }      
    };
   
}
